import { Info } from 'lucide-react';
import { GetCoachAttendanceRollupResult, CoachAttendanceStatus } from '@airreading/common/data';
import { formatCoachAttendanceRollup } from '@/lib/student-group-utils';
import { Tooltip } from '@/components/tooltip';
import { useMemo } from 'react';

interface CoachAttendanceAbsencesProps {
  coachAttendanceRollup: GetCoachAttendanceRollupResult | undefined;
  maxPlannedAbsences: number;
  shortNoticeSubRequestLimit: number;
}

export function CoachAttendanceAbsences({
  coachAttendanceRollup,
  maxPlannedAbsences,
  shortNoticeSubRequestLimit,
}: CoachAttendanceAbsencesProps) {
  const categories = useMemo(() => {
    if (!coachAttendanceRollup) {
      return null;
    }
    return formatCoachAttendanceRollup(coachAttendanceRollup, { maxPlannedAbsences, shortNoticeSubRequestLimit });
  }, [coachAttendanceRollup, maxPlannedAbsences, shortNoticeSubRequestLimit]);

  if (
    !coachAttendanceRollup ||
    coachAttendanceRollup.status === CoachAttendanceStatus.Perfect ||
    coachAttendanceRollup.items.length === 0 ||
    !categories
  ) {
    return <span>-</span>;
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex flex-col gap-1">
        {Object.entries(categories).map(
          ([category, value]) =>
            value.dates.length > 0 && (
              <div key={category}>
                {category}
                {value.detail?.(value.dates.length)}:{' '}
                {value.dates.map((date, index) => (
                  <span key={`${category}-${date.text}-${index}`}>
                    {index > 0 ? ', ' : ''}
                    {date.text}
                    {date.reason && (
                      <Tooltip
                        trigger={
                          <span className="inline-flex align-middle ml-1 cursor-pointer">
                            <Info className="h-3.5 w-3.5 stroke-[#94A3B8] hover:stroke-[#000000]" />
                          </span>
                        }
                      >
                        <div className="whitespace-pre-wrap">Reason: {date.reason}</div>
                      </Tooltip>
                    )}
                  </span>
                ))}
              </div>
            ),
        )}
      </div>
    </div>
  );
}
